// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"4a346fc5","91":"9dd53369","312":"090e3788","569":"656c07c3","846":"8809af72","864":"5d7e6f45"}[chunkId] + ".chunk.js";
};